var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 60",
    style: {
      enableBackground: "new 0 0 210 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Ombre_x0020_port\xE9e{fill:none;}\r\n\t.Arrondis_x0020_2\xA0pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.Miroir_x0020_dynamique\xA0X{fill:none;}\r\n\t.Biseau_x0020_adouci{fill:url(#SVGID_1_);}\r\n\t.Cr\xE9puscule{fill:#FFFFFF;}\r\n\t.Feuillage_GS{fill:#FFDD00;}\r\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51AEE2;}\r\n\t.st0{fill:#030304;}\r\n\t.st1{fill:#020203;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0.7071,
    y2: 0.7071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    style: {
      stopColor: "#E2E2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5D4D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5323,
    style: {
      stopColor: "#C0BFC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#A4A2A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,32.3H38v2c0,8.7-7.2,15-16.1,15C10,49.3,4,40.6,4,30s6.5-19.3,17.9-19.3c8.4,0,14.2,4.7,15.6,12h1.2 C37.4,14.8,31,9.6,21.9,9.6c-11.9,0-19,9-19,20.4c0,11.2,6.4,20.4,19,20.4c7.9,0,14-4,16.2-10.6h0.1v9.8h1.2V31.3H22.4 C22.4,31.3,22.4,32.3,22.4,32.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.9,30.1 46.4,9.6 45,9.6 61.4,31.3 61.4,50.4 62.4,50.4 62.4,31.3 62.4,31.3 78.8,9.6 77.4,9.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.3,9.6c-12.1,0-18.6,9.3-18.6,20.4s6.5,20.4,18.6,20.4s18.6-9.3,18.6-20.4S114.4,9.6,102.3,9.6z  M102.3,49.3C91.5,49.3,85,41.2,84.8,30c0.1-11.2,6.6-19.3,17.5-19.3s17.3,8.1,17.4,19.3C119.7,41.2,113.1,49.3,102.3,49.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,36L136.1,36l-2.4,11.3h-0.9l-2.7-12.3h0.7l2.4,11.3h0l2.3-11.3h0.9l2.3,11.3h0l2.4-11.3h0.7l-2.7,12.3 h-0.9L136.1,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,42.7c0,1.5,0,4.2,2.1,4.2c1.9,0,2.2-1.9,2.2-2.6h0.6c0,1.4-0.8,3.1-2.8,3.1c-2.3,0-2.9-1.9-2.9-5 c0-2.8,1-4.5,3-4.5c2.1,0,2.8,1.8,2.8,4.7L143.1,42.7L143.1,42.7z M147.4,42.1c0-1.6-0.3-3.5-2.1-3.5c-2,0-2.3,2.3-2.3,3.5H147.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,34.9h0.6v4.9h0c0.3-1,0.9-1.8,2.3-1.8c2.3,0,2.8,2,2.8,4.7c0,2.8-0.7,4.7-2.8,4.7c-1.2,0-2-0.7-2.3-1.9 h0v1.7h-0.6L149.6,34.9L149.6,34.9z M150.2,42.7c0,2.6,0.6,4.2,2.2,4.2c1.8,0,2.2-1.9,2.2-4.2c0-2.8-0.5-4.1-2.1-4.1 C150.9,38.6,150.2,39.9,150.2,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.4,46.7c0,2.2-0.6,3.7-2.9,3.7c-2.3,0-2.4-1.8-2.4-2.2h0.6c0,0.9,0.6,1.7,1.9,1.7c1.5,0,2.2-0.9,2.2-2.8 v-1.7h-0.1c-0.3,0.8-0.8,1.8-2.4,1.8c-2.1,0-2.7-2.1-2.7-4.5c0-2.5,0.5-4.7,2.9-4.7c1.2,0,1.9,0.6,2.2,1.7h0v-1.5h0.6L162.4,46.7 L162.4,46.7z M159.6,46.7c1.6,0,2.2-1.7,2.2-4.1c0-2.6-0.7-3.9-2.1-3.9c-1.5,0-2.3,1-2.3,4.1C157.4,45,157.9,46.7,159.6,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.3,38.2h0.6v1.6h0c0.3-1,1.1-1.8,2.3-1.8h0.4v0.6h-0.4c-1.5,0-2.3,1.4-2.3,2.9v5.7h-0.6V38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.2,46.1c0,0.4,0.2,0.6,0.4,0.6c0.2,0,0.3,0,0.4-0.1v0.5c-0.1,0.1-0.4,0.2-0.7,0.2c-0.3,0-0.8-0.3-0.8-1 v-0.6h0c-0.3,0.9-1.1,1.7-2.4,1.7c-1.6,0-2.3-1.1-2.3-2.5c0-1.3,0.5-2.1,1.8-2.5l1.9-0.5c0.8-0.2,0.9-0.6,0.9-1.3 c0-1.6-0.8-2-1.7-2c-1.5,0-2,0.9-2,2.2h-0.6c0-1.2,0.4-2.8,2.5-2.8c2,0,2.5,1.1,2.5,2.4L173.2,46.1L173.2,46.1z M172.6,42L172.6,42 c-0.3,0.4-0.5,0.4-1.2,0.6l-1.3,0.4c-1,0.3-1.4,0.9-1.4,2c0,1.2,0.5,1.9,1.7,1.9c1.5,0,2.3-1.2,2.3-3L172.6,42L172.6,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.1,38.2h0.6v1.6h0c0.3-1,0.9-1.8,2.3-1.8c2.1,0,2.8,2,2.8,4.7c0,2.8-0.7,4.7-2.8,4.7c-1.2,0-2-0.7-2.3-1.9 h0v4.8h-0.6L175.1,38.2L175.1,38.2z M178,46.9c1.8,0,2.2-1.9,2.2-4.2c0-2.9-0.9-4.1-2.1-4.1c-1.7,0-2.3,1.3-2.3,4.1 C175.8,45.3,176.4,46.9,178,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.4,34.9h0.6v4.6h0c0.3-0.8,1.1-1.6,2.3-1.6c1.3,0,2.3,0.7,2.3,2.4v6.8H187v-6.5c0-1.6-0.7-2.2-1.8-2.2 c-1.4,0-2.2,1.3-2.2,2.9v5.8h-0.6L182.4,34.9L182.4,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.5,34.9h0.6v1.8h-0.6V34.9z M189.5,38.2h0.6v9h-0.6V38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.9,40.8v-0.3c0-0.8-0.2-1.9-1.7-1.9c-0.9,0-1.7,0.5-1.7,1.7c0,1,0.4,1.4,1.3,1.8l1.4,0.5 c1.1,0.4,1.6,1.2,1.6,2.4c0,1.5-1.2,2.5-2.6,2.5c-2.5,0-2.7-1.8-2.7-2.9v-0.2h0.6v0.3c0,1.3,0.5,2.2,2,2.2c1.3,0,1.9-0.9,1.9-1.9 c0-0.9-0.3-1.5-1.3-1.8l-1.3-0.5c-1.1-0.4-1.7-1.1-1.7-2.3c0-1.5,1-2.3,2.5-2.3c2,0,2.3,1.3,2.3,2.5v0.3L195.9,40.8L195.9,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,38.2h1.2v-2.7h0.6v2.7h1.5v0.6h-1.5v7c0,0.9,0.4,1,0.8,1c0.3,0,0.5,0,0.8-0.1v0.6 c-0.3,0.1-0.7,0.1-0.9,0.1c-0.9,0-1.3-0.5-1.3-1.5v-7h-1.2V38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.1,42.7c0,1.5,0,4.2,2.1,4.2c1.9,0,2.2-1.9,2.2-2.6h0.6c0,1.4-0.8,3.1-2.8,3.1c-2.3,0-2.9-1.9-2.9-5 c0-2.8,1-4.5,3-4.5c2.1,0,2.8,1.8,2.8,4.7L202.1,42.7L202.1,42.7z M206.4,42.1c0-1.6-0.3-3.5-2.1-3.5c-2,0-2.3,2.3-2.3,3.5H206.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d9d6f4446fef4c9411ad621710611d4.svg";
export { ForwardRef as ReactComponent };